import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';

import css from './usage.scss';
import { UsageBlock } from './components/usage-block';
import { useTranslations } from './hooks/use-translations';

const Usage = ({
    totalSignIns,
    totalTimeOnline,
    totalCurriculumPoints,
    totalLiveMathsPoints,
    showGoldBars,
    totalGoldBars
}) => {
    const { hours, minutes } = totalTimeOnline;
    const {
        signIns,
        timeOnline,
        curriculumPoints,
        liveMathsPoints,
        goldBars
    } = useTranslations();
    return (
        <div className={css.container}>
            {showGoldBars && (
                <UsageBlock
                    info={totalGoldBars}
                    title={goldBars}
                    variant={'goldBar'}
                />
            )}
            <UsageBlock info={totalLiveMathsPoints} title={liveMathsPoints} />
            <UsageBlock info={totalCurriculumPoints} title={curriculumPoints} />
            <UsageBlock info={totalSignIns} title={signIns} />
            <UsageBlock info={`${hours}h ${minutes}min`} title={timeOnline} />
        </div>
    );
};

Usage.propTypes = {
    totalSignIns: PropTypes.number,
    totalTimeOnline: PropTypes.shape({
        hours: PropTypes.number,
        minutes: PropTypes.number
    }),
    totalCurriculumPoints: PropTypes.number,
    totalLiveMathsPoints: PropTypes.number,
    showGoldBars: PropTypes.bool,
    totalGoldBars: PropTypes.number
};

Usage.defaultProps = {
    totalSignIns: 0,
    totalTimeOnline: {
        hours: 0,
        minutes: 0
    },
    totalCurriculumPoints: 0,
    totalLiveMathsPoints: 0,
    totalGoldBars: 0,
    showGoldBars: false
};

export default styleable(css)(Usage);



// WEBPACK FOOTER //
// ./components/usage/usage.js